import React from 'react';

import styled from '@emotion/styled';

import { getStateLayerColor } from '@web/ui/theme/utils';

const TabButtonContainer = styled.div<{ isActive: boolean }>`
  cursor: pointer;
  display: flex;
  height: ${({ theme }) => theme.size['3000']};
  box-sizing: border-box;
  align-items: center;
  padding: ${({ theme }) => theme.spacing('1000')};
  gap: ${({ theme }) => theme.spacing('0500')};
  border-radius: ${({ theme }) => theme.shape.corner['0500']};
  background: ${({ theme, isActive }) =>
    isActive ? theme.color.inverseSurface : theme.color.background};
  transition: border-radius 100ms;

  :hover {
    background-image: ${getStateLayerColor('onBackground', 'hover')};
  }

  :active {
    background-image: ${getStateLayerColor('onBackground', 'active')};
    border-radius: ${({ theme }) => theme.shape.corner['1000']};
  }
`;

const TabButtonLabel = styled.span<{ isActive: boolean }>`
  color: ${({ theme, isActive }) =>
    isActive ? theme.color.onInverseSurface : theme.color.onBackground};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};
`;

const Chip = styled.div`
  box-sizing: border-box;
  height: ${({ theme }) => theme.size['1750']};
  min-width: ${({ theme }) => theme.size['1750']};
  padding: ${({ theme }) => theme.spacing('0500')};
  background: ${({ theme }) => theme.color.yellow};
  border-radius: ${({ theme }) => theme.shape.corner['0250']};
  color: ${({ theme }) => theme.color.onYellow};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['0750']};
  text-align: center;
`;

export interface ITabButtonProps {
  isActive: boolean;
  label: React.ReactNode;
  badgeValue?: number | string;
  onClick(): void;
}

export const TabButton = ({
  isActive,
  label,
  badgeValue,
  onClick,
}: ITabButtonProps) => {
  return (
    <TabButtonContainer isActive={isActive} onClick={onClick}>
      <TabButtonLabel isActive={isActive}>{label}</TabButtonLabel>
      {badgeValue !== undefined && <Chip>{badgeValue}</Chip>}
    </TabButtonContainer>
  );
};
